export const Events = {
    ACCOUNTS_CHANGED: 'accountsChanged',
    CHAIN_CHANGED: 'chainChanged',
    DISCONNECT: 'disconnect',
    CONNECT: 'connect',
};
//# sourceMappingURL=events.js.map